function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n      .cls-1 {\n      fill: #fff;\n      }\n    "));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M66.59,283.12h2.58c.78,0,14.22,1.48,14.22-10.16s-12.82-10.31-14.46-10.31h-2.34v20.47ZM50.26,311.56v-7.66h6.17v-41.1h-6.17v-7.66h21.41c10.94,0,21.88,4.38,21.88,17.81s-10.55,17.81-19.85,17.81h-7.11v13.13h7.19v7.66h-23.52Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M111.57,284.53c0,10.55,8.36,18.91,18.91,18.91,11.64,0,20.08-8.91,20.08-20.39,0-10.86-8.28-19.77-19.22-19.77-12.42,0-19.77,9.3-19.77,21.25M101.41,283.43c0-16.33,12.58-29.53,29.61-29.53s29.69,13.2,29.69,29.53-13.6,29.38-29.69,29.38c-20.63,0-29.61-15.78-29.61-29.38"
});

var _ref5 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "cls-1",
  points: "168.26 311.56 168.26 303.9 174.2 303.9 174.2 262.8 168.26 262.8 168.26 255.15 190.14 255.15 190.14 262.8 184.36 262.8 184.36 303.9 190.14 303.9 190.14 311.56 168.26 311.56"
});

var _ref6 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "cls-1",
  points: "218.73 268.59 218.58 268.59 218.58 303.9 224.91 303.9 224.91 311.56 203.97 311.56 203.97 303.9 209.2 303.9 209.2 262.8 203.97 262.8 203.97 255.15 222.49 255.15 240.45 289.91 240.61 289.91 240.61 262.8 234.83 262.8 234.83 255.15 255.85 255.15 255.85 262.8 249.99 262.8 249.99 311.56 241.79 311.56 218.73 268.59"
});

var _ref7 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "cls-1",
  points: "266.99 270.93 266.99 255.15 309.34 255.15 309.34 270.93 300.36 270.93 300.36 262.8 293.25 262.8 293.25 303.9 300.04 303.9 300.04 311.56 276.29 311.56 276.29 303.9 283.09 303.9 283.09 262.8 275.98 262.8 275.98 270.93 266.99 270.93"
});

var _ref8 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "cls-1",
  points: "50.26 187.21 50.26 202.99 59.24 202.99 59.24 194.86 66.35 194.86 66.35 235.96 59.55 235.96 59.55 243.62 83.31 243.62 83.31 235.96 76.51 235.96 76.51 194.86 83.62 194.86 83.62 202.99 92.6 202.99 92.6 187.21 50.26 187.21"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M114.48,210.33h6.56c5.63,0,11.25-.94,11.25-8.52,0-6.95-7.11-6.95-12.42-6.95h-5.39v15.47ZM98.31,243.62v-7.66h6.02v-41.1h-6.02v-7.66h24.22c3.83,0,12.11-.63,17.42,6.41,2.58,3.28,2.5,6.8,2.5,7.66,0,6.56-2.89,10.31-8.83,12.82v.15c6.41,1.56,6.95,5.55,6.95,8.99v12.73h5.47v7.66h-15.63v-19.77c0-5.31-5.7-5.86-9.84-5.86h-6.09v17.97h6.25v7.66h-22.42Z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M177.06,198.22h.16l6.33,19.07h-12.97l6.48-19.07ZM162.92,187.21v7.66h6.17l-14.06,41.1h-4.61v7.66h20.23v-7.66h-6.09l3.83-11.02h17.11l3.83,11.02h-6.17v7.66h20.78v-7.66h-4.3l-13.67-41.1h6.09v-7.66h-29.14Z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M224.49,236.12h5.7c14.14,0,19.61-10.7,19.61-20.86,0-9.06-5-20.39-20.39-20.39h-4.92v41.25ZM214.33,194.86h-6.02v-7.66h20.08c13.59,0,18.36,4.45,20.94,6.17,2.11,1.41,10.63,9.22,10.63,22.74,0,10.55-7.03,18.21-8.75,19.53-5.94,4.61-10.7,7.97-23.36,7.97h-19.53v-7.66h6.02v-41.1Z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "cls-1",
  points: "265.51 187.21 265.51 194.86 271.52 194.86 271.52 235.96 265.51 235.96 265.51 243.62 308.95 243.62 308.95 226.74 299.96 226.74 299.96 235.96 281.68 235.96 281.68 217.99 297.38 217.99 297.38 209.08 281.68 209.08 281.68 194.86 299.96 194.86 299.96 202.13 308.95 202.13 308.95 187.21 265.51 187.21"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M427.96,305.21l-33.26-.18,3.82-3.79-14.1-14.24h-.05l-14.1,14.24,3.82,3.79-33.26.18-.11-33.27,4.38,4.34,15.08-15.23,24.2,23.97h.05l24.2-23.97,15.08,15.23,4.38-4.34-.11,33.27ZM384.4,198.33l32.51,32.61h-8.54s0,29.65,0,29.65h-48v-29.68h-8.51s32.54-32.58,32.54-32.58ZM384.47,188.41l-66.52,64h16.97v59.17h97.8v-59.12h17.01s-65.27-64.05-65.27-64.05Z"
});

var SvgTradepointLogo = function SvgTradepointLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 180,
    height: 150,
    style: {
      backgroundColor: "#000"
    },
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "110 140 250 250 ",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTradepointLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tradepoint-logo.c584466f.svg";
export { ForwardRef as ReactComponent };